import { useEffect } from "react"
import { AppRouter } from "navigation/AppRouter"
import { applyTheme, useThemeStore } from "hooks/useTheme"

function App() {
  const theme = useThemeStore((state) => state.theme)

  // Keep the document in sync with the theme setting, and follow the OS
  // preference live while the user is on "system".
  useEffect(() => {
    applyTheme(theme)

    if (theme !== "system") return

    const media = window.matchMedia("(prefers-color-scheme: dark)")
    const onChange = () => applyTheme("system")
    media.addEventListener("change", onChange)
    return () => media.removeEventListener("change", onChange)
  }, [theme])

  return <AppRouter />
}

export default App
